import React, { useEffect, useState, useContext } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { WorkspaceContext } from "../contexts/WorkspaceContext";
import { getInvitation, joinWorkspace } from "../services/workspace-management";
import Navbar from "../components/Navbar";
import Person from "../components/Person";
import appLogo from "../assets/img/app_logo.png";
import { IoLogInOutline } from "react-icons/io5";

export default function InvitePage() {
  const { token } = useParams();
  const navigate = useNavigate();
  const { selectWorkspace } = useContext(WorkspaceContext);
  const [info, setInfo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [joining, setJoining] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!token) return;
    setLoading(true);
    getInvitation(token)
      .then((data) => {
        if (data.workspace) {
          setInfo(data.workspace);
        } else {
          setError(data.msg || "Code d'invitation invalide.");
        }
      })
      .catch(() => setError("Erreur réseau."))
      .finally(() => setLoading(false));
  }, [token]);

  const handleJoin = async () => {
    if (!token) return;
    setJoining(true);
    try {
      const data = await joinWorkspace(token);
      if (data.workspace) {
        selectWorkspace({ ...data.workspace, role: data.role, permissions: data.permissions });
        navigate("/");
      } else {
        setError(data.msg || "Impossible de rejoindre cet espace.");
      }
    } catch {
      setError("Erreur réseau.");
    } finally {
      setJoining(false);
    }
  };

  return (
    <>
      <Navbar />
      <div className="tyn-content tyn-auth tyn-auth-centered">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-xl-4 col-lg-5 col-md-7 col-sm-9">
              <div className="text-center animate__animated animate__infinite animate__pulse">
                <img
                  className="tyn-logo taille-du-logoform my-tyn-logo"
                  src={appLogo}
                  alt="Logo_app"
                />
              </div>

              <div className="card border-0">
                {loading ? (
                  <div className="p-4 text-center">
                    <div className="spinner-border text-primary" role="status">
                      <span className="visually-hidden">Chargement...</span>
                    </div>
                  </div>
                ) : error ? (
                  <div className="p-4 text-center">
                    <h4>Invitation invalide</h4>
                    <p className="text-muted mb-3">{error}</p>
                    <button
                      className="btn btn-primary"
                      onClick={() => navigate("/workspaces")}
                    >
                      Voir mes espaces
                    </button>
                  </div>
                ) : info ? (
                  <div className="p-4 text-center">
                    <div
                      className="tyn-media tyn-size-xl tyn-circle mx-auto mb-3 d-flex align-items-center justify-content-center"
                      style={{
                        width: 72,
                        height: 72,
                        overflow: "hidden",
                      }}
                    >
                      {info.imageUrl ? (
                        <img
                          src={info.imageUrl}
                          alt={info.nom}
                          style={{
                            width: "100%",
                            height: "100%",
                            borderRadius: "50%",
                            objectFit: "cover",
                          }}
                        />
                      ) : (
                        <Person
                          person={{
                            image: null,
                            nom: info.nom,
                            prenom: "",
                            userId: info._id,
                            colors: info.color,
                          }}
                        />
                      )}
                    </div>

                    <h4>{info.nom}</h4>
                    {info.description && (
                      <p className="text-muted mb-1">{info.description}</p>
                    )}
                    <p className="text-muted small mb-3">
                      {info.memberCount} membre{info.memberCount > 1 ? "s" : ""}
                    </p>

                    <div className="d-flex gap-2 justify-content-center">
                      <button
                        className="btn btn-primary"
                        onClick={handleJoin}
                        disabled={joining}
                      >
                        {joining ? (
                          <span className="spinner-border spinner-border-sm me-1" />
                        ) : (
                          <IoLogInOutline className="me-1" />
                        )}
                        {joining ? "Inscription..." : "Rejoindre cet espace"}
                      </button>
                    </div>
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
